import React from "react";
import axios from "axios";
import { API_GET, API_POST } from "../../services/api.service";

import PropTypes from "prop-types";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardAvatar from "components/Card/CardAvatar.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import Snackbar from "components/Snackbar/Snackbar.jsx";
import avatar from "assets/img/faces/marc.jpg";

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
};

const { REACT_APP_SERVER_URL } = process.env;

class UserProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      user: null,
      notify: {
        open: false,
        message: "",
        color: "success",
      },
      profileData: [],
      verifyingGST: false,
      gstDetails: null
    };
    this.updateProfile = this.updateProfile.bind(this);
  }

  verifyBusinessGST = async (gstin) => {
    if (!gstin || gstin.length !== 15) {
      this.setState({ gstDetails: null });
      return;
    }

    this.setState({ verifyingGST: true });
    try {
      let response = await API_GET(`mongodb/verifyGST/${gstin}`);
      if (response && response.success) {
        this.setState({ gstDetails: response.data });
        // Optionally auto-fill company name and address if they are empty
        if (!this.state.businessDetails || !this.state.businessDetails.company_name) {
          this.setState(prevState => ({
            businessDetails: {
              ...prevState.businessDetails,
              company_name: response.data.lgnm || response.data.tradeNam
            }
          }));
        }
      } else {
        this.setState({ gstDetails: null });
      }
    } catch (err) {
      console.error("GST Verification Error:", err);
      this.setState({ gstDetails: null });
    } finally {
      this.setState({ verifyingGST: false });
    }
  };

  loadUserInfo = async (username) => {
    debugger;
    let userInfo = await API_GET(
      `register/GetProfileData?username=${username}`
    );
    debugger;
    if (userInfo.success) {
      this.setState({ profileData: userInfo.data });
    } else {
      this.setState({ profileData: null });
    }
  };

  async updateProfile(e) {
    e.preventDefault();
    debugger;

    const fields = ["firstName", "lastName", "email", "Phone"];
    // const formElements = e.target.elements;
    // let formValues = fields
    //   .map((field) => ({
    //     [field]: formElements.namedItem(field).value,
    //   }))
    //   .reduce((current, next) => ({ ...current, ...next }));

    let registerRequest;
    //var ab=this.state.profileData;
    // formValues = {
    //   username: this.state.username,
    //   id: this.state.user.id,
    //   firstName:
    //     formValues.firstName == ""
    //       ? this.state.profileData.first_name
    //       : formValues.firstName,
    //   lastName:
    //     formValues.lastname == ""
    //       ? this.state.profileData.last_name
    //       : formValues.lastName,
    //   Phone:
    //     formValues.Phone == ""
    //       ? this.state.profileData.phone
    //       : formValues.Phone,
    //   email:
    //     formValues.email == ""
    //       ? this.state.profileData.email
    //       : formValues.email,
    // };
    let formValues = this.state.profileData;
    debugger;
    try {
      // First update the standard profile data
      let registerRequest = await API_POST("register/updateProfileData", {
        ...formValues,
      });

      // Then update business details in Configuration/basic if they exist
      if (this.state.businessDetails) {
        await API_POST("action/upsert", {
          root: "Configuration",
          body: {
            ...this.state.businessDetails,
            configName: "basic",
            admin: this.state.user.admin,
            updatedOn: new Date()
          },
          querydata: { configName: "basic", admin: this.state.user.admin },
        });
      }

      if (registerRequest && registerRequest.data.update) {
        this.setState({
          notify: {
            open: true,
            message: "Data Save successfully",
            color: "success",
          },
        });
        this.loadUserInfo(this.state.user.username);
      }
    } catch ({ response }) {
      registerRequest = response;
    }
  }

  async componentDidMount() {
    let getSessionRequest;
    getSessionRequest = await API_GET(`get-session`);

    if (getSessionRequest && getSessionRequest.success) {
      this.setState({ user: getSessionRequest.userInfo });
      
      // Load business details from Configuration/basic
      try {
        let businessRequest = await API_POST("action/getdata", {
          root: "Configuration",
          con: { configName: "basic", admin: getSessionRequest.userInfo.admin },
          cols: {},
        });
        if (businessRequest && businessRequest.status == 200 && businessRequest.data && businessRequest.data.length > 0) {
          this.setState({ businessDetails: businessRequest.data[0] });
        }
      } catch (err) {
        console.error("Error loading business details:", err);
      }
    }

    this.loadUserInfo(getSessionRequest.userInfo.username);
  }

  handleBusinessChange = (e) => {
    const { name, value } = e.target;
    this.setState(prevState => ({
      businessDetails: {
        ...prevState.businessDetails,
        [name]: value
      }
    }), () => {
      if (name === "gstnumber" && value.length === 15) {
        this.verifyBusinessGST(value);
      } else if (name === "gstnumber") {
        this.setState({ gstDetails: null });
      }
    });
  };
  render() {
    const { classes, name, email } = this.props;
    const { errors, user } = this.state;

    if (!user) {
      return null;
    }

    return (
      <div>
        <Snackbar
          place="tr"
          color={this.state.notify.color}
          message={this.state.notify.message}
          open={this.state.notify.open}
          closeNotification={() =>
            this.setState({
              notify: {
                open: false,
              },
            })
          }
          close
        />
        <GridContainer>
          <GridItem xs={12} sm={12} md={8}>
            <form onSubmit={this.updateProfile}>
              <Card>
                <CardHeader color="primary">
                  <h4 className={classes.cardTitleWhite}>My Profile</h4>
                  <p className={classes.cardCategoryWhite}>
                    Complete your profile
                  </p>
                </CardHeader>
                <CardBody>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={9}>
                      <CustomInput
                        labelText="FirstName"
                        id="firstName"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        labelProps={{ shrink: true }}
                        inputProps={{
                          // onChange: (e) => {
                          //   this.setState(() => ({
                          //     profileData: {
                          //       ...this.state.profileData,
                          //       first_name: e.target.value
                          //     }
                          //   }));
                          // },

                          // onChange: (e) => {
                          //   this.setState(prevState => ({
                          //     profileData: {
                          //       ...prevState.profileData,
                          //       first_name: e.target.value,
                          //     }
                          //   }));
                          // },
                          onChange: (e) => {
                            this.setState((prevState) => ({
                              profileData: {
                                ...prevState.profileData,
                                first_name: e.target.value,
                              },
                            }));
                          },
                          value:
                            this.state.profileData &&
                            this.state.profileData.first_name,
                          //this.state.profileData &&
                          //this.state.profileData.username,
                          name: "firstName",
                        }}
                      />
                      <CustomInput
                        labelText="Last Name"
                        id="lastName"
                        error={errors.name}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        labelProps={{ shrink: true }}
                        inputProps={{
                          value:
                            this.state.profileData &&
                            this.state.profileData.last_name,

                          onChange: (e) => {
                            this.setState((prevState) => ({
                              profileData: {
                                ...prevState.profileData,
                                last_name: e.target.value,
                              },
                            }));
                          },
                          name: "lastName",
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={9}>
                      <CustomInput
                        labelText="Email address"
                        id="email-address"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        disabled
                        labelProps={{ shrink: true }}
                        inputProps={{
                          value:
                            this.state.profileData &&
                            this.state.profileData.email,
                          name: "email",
                          disabled: true,
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={9}>
                      <CustomInput
                        labelText="Phone"
                        id="Phone"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        labelProps={{ shrink: true }}
                        inputProps={{
                          pattern: "[0-9]*",
                          maxLength: 10,
                          type: "number",

                          value:
                            this.state.profileData &&
                            this.state.profileData.phone,
                          name: "phone",

                          onChange: (e) => {
                            this.setState((prevState) => ({
                              profileData: {
                                ...prevState.profileData,
                                phone: e.target.value,
                              },
                            }));
                          },
                          //value: Count,
                          //onChange: (e) => {
                          //setCount(e.target.value);
                          //},
                        }}
                      />
                    </GridItem>
                  </GridContainer>
                </CardBody>
                <CardFooter>
                  <Button type="submit" color="primary">
                    Update Profile
                  </Button>
                </CardFooter>
              </Card>

              {/* Business Details Section */}
              <Card style={{ marginTop: "30px" }}>
                <CardHeader color="info">
                  <h4 className={classes.cardTitleWhite}>Business Details</h4>
                  <p className={classes.cardCategoryWhite}>
                    Manage your company and bank information
                  </p>
                </CardHeader>
                <CardBody>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <CustomInput
                        labelText="GST Number"
                        id="gstnumber"
                        formControlProps={{ fullWidth: true }}
                        labelProps={{ shrink: true }}
                        inputProps={{
                          value: this.state.businessDetails && this.state.businessDetails.gstnumber || "",
                          name: "gstnumber",
                          onChange: this.handleBusinessChange
                        }}
                      />
                      {this.state.verifyingGST && <p style={{ fontSize: '12px', color: '#1976d2' }}>Verifying GST...</p>}
                      {this.state.gstDetails && (
                        <div style={{ padding: '10px', backgroundColor: '#f0f7ff', border: '1px solid #1976d2', borderRadius: '4px', marginTop: '5px' }}>
                          <p style={{ margin: 0, fontSize: '12px' }}><strong>Legal Name:</strong> {this.state.gstDetails.lgnm}</p>
                          <p style={{ margin: 0, fontSize: '12px' }}><strong>Status:</strong> <span style={{ color: this.state.gstDetails.sts === 'Active' ? 'green' : 'red' }}>{this.state.gstDetails.sts}</span></p>
                        </div>
                      )}
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <CustomInput
                        labelText="Company Name"
                        id="company_name"
                        formControlProps={{ fullWidth: true }}
                        labelProps={{ shrink: true }}
                        inputProps={{
                          value: this.state.businessDetails && this.state.businessDetails.company_name || "",
                          name: "company_name",
                          onChange: this.handleBusinessChange
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <CustomInput
                        labelText="Company Address"
                        id="company_address"
                        formControlProps={{ fullWidth: true }}
                        labelProps={{ shrink: true }}
                        inputProps={{
                          value: this.state.businessDetails && this.state.businessDetails.company_address || "",
                          name: "company_address",
                          onChange: this.handleBusinessChange
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <CustomInput
                        labelText="Bank Name"
                        id="bank_name"
                        formControlProps={{ fullWidth: true }}
                        labelProps={{ shrink: true }}
                        inputProps={{
                          value: this.state.businessDetails && this.state.businessDetails.bank_name || "",
                          name: "bank_name",
                          onChange: this.handleBusinessChange
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <CustomInput
                        labelText="Account Number"
                        id="account_number"
                        formControlProps={{ fullWidth: true }}
                        labelProps={{ shrink: true }}
                        inputProps={{
                          value: this.state.businessDetails && this.state.businessDetails.account_number || "",
                          name: "account_number",
                          onChange: this.handleBusinessChange
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <CustomInput
                        labelText="IFSC Code"
                        id="ifsc_code"
                        formControlProps={{ fullWidth: true }}
                        labelProps={{ shrink: true }}
                        inputProps={{
                          value: this.state.businessDetails && this.state.businessDetails.ifsc_code || "",
                          name: "ifsc_code",
                          onChange: this.handleBusinessChange
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={6} md={6}>
                      <CustomInput
                        labelText="Branch Name"
                        id="branch_name"
                        formControlProps={{ fullWidth: true }}
                        labelProps={{ shrink: true }}
                        inputProps={{
                          value: this.state.businessDetails && this.state.businessDetails.branch_name || "",
                          name: "branch_name",
                          onChange: this.handleBusinessChange
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={6} md={4}>
                      <CustomInput
                        labelText="Website"
                        id="website"
                        formControlProps={{ fullWidth: true }}
                        labelProps={{ shrink: true }}
                        inputProps={{
                          value: this.state.businessDetails && this.state.businessDetails.website || "",
                          name: "website",
                          onChange: this.handleBusinessChange
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={6} md={4}>
                      <CustomInput
                        labelText="Contact Email"
                        id="contact_email"
                        formControlProps={{ fullWidth: true }}
                        labelProps={{ shrink: true }}
                        inputProps={{
                          value: this.state.businessDetails && this.state.businessDetails.contact_email || "",
                          name: "contact_email",
                          onChange: this.handleBusinessChange
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={6} md={4}>
                      <CustomInput
                        labelText="Contact Phone"
                        id="contact_phone"
                        formControlProps={{ fullWidth: true }}
                        labelProps={{ shrink: true }}
                        inputProps={{
                          value: this.state.businessDetails && this.state.businessDetails.contact_phone || "",
                          name: "contact_phone",
                          onChange: this.handleBusinessChange
                        }}
                      />
                    </GridItem>
                  </GridContainer>
                </CardBody>
                <CardFooter>
                  <Button type="submit" color="info">
                    Update Business Details
                  </Button>
                </CardFooter>
              </Card>
            </form>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <Card profile className="ProfileSection">
              <CardHeader color="primary">
                <h4 className={classes.cardTitleWhite}>Company Details</h4>
              </CardHeader>
              {/* <CardAvatar profile>
                <a href="#pablo" onClick={(e) => e.preventDefault()}>
                  <img src={avatar} alt="..." />
                </a>
              </CardAvatar> */}
              <CardBody profile>
                {/* <h6 className={classes.cardCategory}>CEO / CO-FOUNDER</h6> */}
                <h4 className={classes.cardTitle}>
                  {this.state.profileData && this.state.profileData.company}
                </h4>
                {/* <p className={classes.description}>
                  
                </p> */}
                <GridContainer >
                  <GridItem xs={12} sm={6} md={4} style={{ fontWeight: 500 }}>
                    FirstName:
                  </GridItem>
                  <GridItem xs={12} sm={6} md={8}>
                    {this.state.profileData &&
                      this.state.profileData.first_name}
                  </GridItem>
                </GridContainer>

                <GridContainer >
                  <GridItem xs={12} sm={6} md={4} style={{ fontWeight: 500 }}>
                    LastName:
                  </GridItem>
                  <GridItem xs={12} sm={6} md={8}>
                    {this.state.profileData && this.state.profileData.last_name}
                  </GridItem>
                </GridContainer>

                <GridContainer >
                  <GridItem xs={12} sm={6} md={4} style={{ fontWeight: 500 }}>
                    username:
                  </GridItem>
                  <GridItem xs={12} sm={6} md={8}>
                    {this.state.profileData && this.state.profileData.username}
                  </GridItem>
                </GridContainer>

                <GridContainer >
                  <GridItem xs={12} sm={6} md={4} style={{ fontWeight: 500 }}>
                    Phone:
                  </GridItem>
                  <GridItem xs={12} sm={6} md={8}>
                    {this.state.profileData && this.state.profileData.phone}
                  </GridItem>
                </GridContainer>

                <GridContainer >
                  <GridItem xs={12} sm={6} md={4} style={{ fontWeight: 500 }}>
                    Email:
                  </GridItem>
                  <GridItem xs={12} sm={6} md={8}>
                    {this.state.profileData && this.state.profileData.email}
                  </GridItem>
                </GridContainer>

                <GridContainer >
                  <GridItem xs={12} sm={6} md={4} style={{ fontWeight: 500 }}>
                    Company Size:
                  </GridItem>
                  <GridItem xs={12} sm={6} md={8}>
                    {this.state.profileData &&
                      this.state.profileData.company_size}
                  </GridItem>
                </GridContainer>
                <GridContainer >
                  <GridItem xs={12} sm={6} md={6} style={{ fontWeight: 500 }}>
                  Last Call Details:
                  </GridItem>
                  <GridItem xs={12} sm={6} md={6}>
                    {this.state.profileData &&
                      this.state.profileData.lastSyncData &&
                      this.state.profileData.lastSyncData.CallDetails && 
                      this.state.profileData.lastSyncData.CallDetails.length>0 && 
                      window.moment(this.state.profileData.lastSyncData.CallDetails[0].startDate).format("DD-MMM-YYYY HH:mm")
                      
                      }
                  </GridItem>
                </GridContainer>
                <GridContainer >
                  <GridItem xs={12} sm={6} md={6} style={{ fontWeight: 500 }}>
                  Last Recording:
                  </GridItem>
                  <GridItem xs={12} sm={6} md={6}>
                  {this.state.profileData &&
                      this.state.profileData.lastSyncData &&
                      this.state.profileData.lastSyncData.CallRecording && 
                      this.state.profileData.lastSyncData.CallRecording.length>0 && 
                      window.moment(this.state.profileData.lastSyncData.CallRecording[0].startDate).format("DD-MMM-YYYY HH:mm")
                      
                      }
                  </GridItem>
                </GridContainer>

                {/* <Button color="primary" round>
                  Follow
                </Button> */}
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

UserProfile.propTypes = {
  classes: PropTypes.object.isRequired,
  name: PropTypes.string,
  email: PropTypes.string,
};

export default withStyles(styles)(UserProfile);
